import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BriefcaseBusiness, CheckCircle2, Mail, Send } from 'lucide-react';
import { profile } from '../data/content';

export function Hero() {
  const [roleIndex, setRoleIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setRoleIndex((index) => (index + 1) % profile.animatedRoles.length);
    }, 1900);

    return () => window.clearInterval(timer);
  }, []);

  return (
    <section className="hero section-band" id="home">
      <div className="hero-shell">
        <motion.div
          className="hero-copy"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          <span className="status-pill">
            <CheckCircle2 size={17} />
            {profile.availability}
          </span>
          <p className="hero-kicker">{profile.nickname}</p>
          <h1>{profile.name}</h1>
          <div className="typing-line" aria-live="polite">
            <span>{profile.animatedRoles[roleIndex]}</span>
          </div>
          <p className="hero-summary">{profile.summary}</p>

          <div className="hero-actions">
            <a className="btn btn-primary" href="#projects">
              <BriefcaseBusiness size={18} />
              My works
            </a>
            <a className="btn btn-success" href="#order">
              <Send size={18} />
              Order Service
            </a>
            <a className="btn btn-ghost" href="#contacts">
              <Mail size={18} />
              Contact Me
            </a>
          </div>
        </motion.div>

        <motion.div
          className="hero-panel"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.1, ease: 'easeOut' }}
        >
          <div className="terminal-top">
            <span />
            <span />
            <span />
          </div>
          <div className="terminal-lines">
            <p>
              <span>const</span> portfolio = buildPremiumUI()
            </p>
            <p>
              <span>await</span> connectFirebase()
            </p>
            <p>
              <span>ship</span>({`{ seo: true, payments: true }`})
            </p>
          </div>
          <div className="hero-metrics">
            <div>
              <strong>98</strong>
              <span>Performance</span>
            </div>
            <div>
              <strong>24/7</strong>
              <span>Support-ready</span>
            </div>
            <div>
              <strong>1.0</strong>
              <span>Launch build</span>
            </div>
          </div>
          <a className="panel-link" href="#services">
            Services
            <ArrowRight size={16} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
